import { ReactNode } from "react";
import cx from "classnames";

import { ChevronRight } from "components/icons/generated";
import Box from "ds/components/Box";
import ButtonIcon, { ButtonIconProps } from "ds/components/ButtonIcon";
import { ariaCellInteractionProps } from "ds/components/Table/hooks/useKeyboardNavigation/ariaCellInteractionProps";

import styles from "./styles.module.css";

type TableCellGroupProps = {
  isActive: boolean;
  loading?: boolean;
  onPress: ButtonIconProps["onPress"];
  isGroupOpen?: boolean;
  children: ReactNode;
  title: string;
};

const TableCellGroup = ({
  isActive,
  loading,
  onPress,
  isGroupOpen,
  children,
  title,
}: TableCellGroupProps) => {
  if (!isActive) {
    return children;
  }

  return (
    <Box gap="medium" align="center">
      <ButtonIcon
        loading={loading}
        variant="ghost"
        onPress={onPress}
        {...ariaCellInteractionProps}
        icon={ChevronRight}
        className={cx(styles.chevronButton, {
          [styles.open]: isGroupOpen,
        })}
      >
        {title}
      </ButtonIcon>

      {children}
    </Box>
  );
};

TableCellGroup.displayName = "DS.Table.CellGroup";

export default TableCellGroup;
